import { isSequenceApiError, isSequenceApiErrorResponse } from '@sequencehq/api'

/**
 * Prefer the backend-provided message so users get actionable detail (e.g. a
 * validation error pointing at a bad filter or an out-of-range date span)
 * rather than a generic fallback toast. The rev-rec export/report endpoints
 * return their human message on the top-level `error.message`.
 */
export const extractApiErrorMessage = (
  error: unknown,
  fallback: string
): string => {
  if (
    isSequenceApiError(error) &&
    isSequenceApiErrorResponse(error.response) &&
    error.response.error.message
  ) {
    return error.response.error.message
  }
  return fallback
}
